import './Flow.svelte.css.proxy.js';
/* src/components/recruit/Flow.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let div4;
	let ul;
	let li0;
	let div0;
	let p0;
	let t0;
	let t1;
	let li1;
	let div1;
	let p1;
	let t2;
	let t3;
	let li2;
	let div2;
	let p2;
	let t4;
	let t5;
	let li3;
	let div3;
	let p3;
	let t6;

	return {
		c() {
			div4 = element("div");
			ul = element("ul");
			li0 = element("li");
			div0 = element("div");
			p0 = element("p");
			t0 = text("お問い合わせフォーム（メール）または電話でご連絡ください。");
			t1 = space();
			li1 = element("li");
			div1 = element("div");
			p1 = element("p");
			t2 = text("応募書類（履歴書等）をご郵送ください。");
			t3 = space();
			li2 = element("li");
			div2 = element("div");
			p2 = element("p");
			t4 = text("面接の日時をご連絡いたします。（面接は1〜2回実施致します。）");
			t5 = space();
			li3 = element("li");
			div3 = element("div");
			p3 = element("p");
			t6 = text("最終面接後、1週間程度で採用の可否をご連絡致します。");
			this.h();
		},
		l(nodes) {
			div4 = claim_element(nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			ul = claim_element(div4_nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			div0 = claim_element(li0_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p0 = claim_element(div0_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "お問い合わせフォーム（メール）または電話でご連絡ください。");
			p0_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			t1 = claim_space(ul_nodes);
			li1 = claim_element(ul_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			div1 = claim_element(li1_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			p1 = claim_element(div1_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t2 = claim_text(p1_nodes, "応募書類（履歴書等）をご郵送ください。");
			p1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			t3 = claim_space(ul_nodes);
			li2 = claim_element(ul_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			div2 = claim_element(li2_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			p2 = claim_element(div2_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t4 = claim_text(p2_nodes, "面接の日時をご連絡いたします。（面接は1〜2回実施致します。）");
			p2_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			li2_nodes.forEach(detach);
			t5 = claim_space(ul_nodes);
			li3 = claim_element(ul_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			div3 = claim_element(li3_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			p3 = claim_element(div3_nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t6 = claim_text(p3_nodes, "最終面接後、1週間程度で採用の可否をご連絡致します。");
			p3_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			li3_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "svelte-1c4op4u");
			attr(div0, "class", "svelte-1c4op4u");
			attr(li0, "class", "svelte-1c4op4u");
			attr(p1, "class", "svelte-1c4op4u");
			attr(div1, "class", "svelte-1c4op4u");
			attr(li1, "class", "svelte-1c4op4u");
			attr(p2, "class", "svelte-1c4op4u");
			attr(div2, "class", "svelte-1c4op4u");
			attr(li2, "class", "svelte-1c4op4u");
			attr(p3, "class", "svelte-1c4op4u");
			attr(div3, "class", "svelte-1c4op4u");
			attr(li3, "class", "svelte-1c4op4u");
			attr(ul, "class", "svelte-1c4op4u");
			attr(div4, "class", "flow svelte-1c4op4u");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, ul);
			append(ul, li0);
			append(li0, div0);
			append(div0, p0);
			append(p0, t0);
			append(ul, t1);
			append(ul, li1);
			append(li1, div1);
			append(div1, p1);
			append(p1, t2);
			append(ul, t3);
			append(ul, li2);
			append(li2, div2);
			append(div2, p2);
			append(p2, t4);
			append(ul, t5);
			append(ul, li3);
			append(li3, div3);
			append(div3, p3);
			append(p3, t6);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div4);
		}
	};
}

class Flow extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Flow;
//# sourceMappingURL=Flow.svelte.js.map
